import useFocused from '../hooks/useFocused';
const FocusProvider = props => {
  return props.children(useFocused(props));
};
FocusProvider.displayName = 'FocusProvider';
export default FocusProvider;